import { Icon } from "@/react/components/shared/Icon";

interface ExploreButtonProps {
  onClick: () => void;
  text: string;
}

const ExploreButton = ({ text, onClick }: ExploreButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    className="border-default bg-primary hover:bg-secondary dark:border-tertiary hover:dark:bg-tertiary mb-2 flex h-11 w-[368px] items-center justify-between gap-2 rounded-lg border px-5 py-3 shadow-[0px_1px_2px_0px_#0000000D]"
  >
    <div className="text-[14px] font-semibold leading-[20px]">{text}</div>
    <Icon type="sw-right-arrow" size={16} />
  </button>
);

export default ExploreButton;
